<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Incoming PDC</li>
		</ol>

        <h1 class="page-header">Incoming PDC</h1>
        <hr>

         <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row ">
                <!-- <div class="col-lg-3 col-xs-12 " style="padding-left:0" >
                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-3 col-form-label">Status</label>
                        <div class="col-sm-9">
                            <select class="form-control" style="width:100%" v-model="filter.status">
                                <option value="" selected>All Status</option>
                                <option value="Success">Success</option>
                                <option value="Failed">Failed</option>
                            </select>
                        </div>
                    </div>
                </div> -->
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-2 col-form-label col-xs-12"  style="padding-left:0">Month </label>
                        <select class="form-control w-75" v-model="filter.month">
                            <option v-for="(month, index) in monthList" :value="index">{{month}}</option>

                        </select>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-2 col-form-label col-xs-12"  style="padding-left:0">Year</label>
                        <select class="form-control w-75" v-model="filter.year">
                            <option v-for="year in yearList">{{year}}</option>

                        </select>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row">
                        <label class="col-sm-2 col-form-label col-xs-12"  style="padding-left:0">Location</label>
                        <select class="form-control w-75" v-model="selected.location">
                            <option>All PDC</option>
                            <option v-if="options.pdc" v-for="pdc in options.pdc">{{pdc}}</option>
                        </select>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-2 offset-lg-1 col-xs-12">
                    <input type="button" class="btn btn-primary float-right" style="width:100%" @click="search()" value="Search"></input>
                </div>
            </div>
        </panel>

        <div class="row mt-4">
            <div class="col-lg-4 col-xs-12">
                <div class="widget widget-stats bg-green border border-black">
                    <div class="stats-info">
                        <p v-if="stats">{{stats.total ? numberWithCommas(stats.total) : 0}}</p>
                        <p v-else>Loading....</p>
                        <h4>GRAND TOTAL</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-xs-12">
                <div class="widget widget-stats bg-blue border border-black">
                    <div class="stats-info">
                        <p v-if="stats">{{stats.pagi ? numberWithCommas(stats.pagi) : 0}}</p>
                        <p v-else>Loading....</p>
                        <h4>TOTAL SHIFT PAGI (06:30 - 20:29)</h4>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-xs-12">
                <div class="widget widget-stats bg-red border border-black">
                    <div class="stats-info">
                        <p v-if="stats">{{stats.malam ? numberWithCommas(stats.malam) : 0}}</p>
                        <p v-else>Loading....</p>
                        <h4>TOTAL SHIFT MALAM (20:30 - 06:29)</h4>
                    </div>
                </div>
            </div>
        </div>

        <!---Table Report Log Start-->
        <panel class="border border-secondary" @clicked="getData(1)">
            <template slot="header">
                <h4 class="panel-title">Detailed Information</h4>
            </template>
            <incomingTable class="mt-4" v-if="filterReady" :data="data" :anotherData="anotherData" :filter="filterTable" ></incomingTable>
        </panel>
    </div> 
</template>

<script>
    import DateRangePicker from "vue2-daterange-picker";
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

    import * as am4core from "@amcharts/amcharts4/core";
    import moment from 'moment';

    // import child components
    import incomingTable from './childComponents/incomingTable'
    
    export default{
        data(){
            var filter = {
                month : new Date().getMonth(),
                year : new Date().getFullYear(),
                location : null,
            }

            let filterTable = JSON.parse(JSON.stringify(filter))
            let yearList = [];
            let yearNow = new Date().getFullYear();

            for(var i = 0 ; i < 10 ; i++){
                yearList.push(yearNow - i);
            }

            return{
                filter : filter,
                filterTable : filterTable,
                filterReady : false,
                searchButton : false,
                yearList : yearList,
                monthList : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
                data : null,
                anotherData: null,
                options : {
                    pdc : this.$store.getters.getPdc,
                },
                selected : {
                    location : 'All PDC',
                },
                stats : {
                    pagi : 0,
                    malam : 0,
                    total : 0
                },
                CancelToken : this.$http.CancelToken,
                source : null
            }
        },
        components : {
            DateRangePicker,
            incomingTable
        },
        beforeDestroy(){
            am4core.disposeAllCharts();
        },
        watch : {
            'filter' : {
                handler : 'initialiseFilter',
                deep : true
            },
            'selected.location' () {
                if (this.selected.location == 'All PDC') this.filter.location = null
                else this.filter.location = this.selected.location
            }
        },
        async mounted(){
            this.initialiseFilter();
            await this.getData(0);
        },
        sockets : {
            incomingVehicle : function(data){
                if(this.filter.month == data.month && this.filter.year == data.year){
                    this.stats.total += data.total;
                    if(data.shift == "pagi"){
                        this.stats.pagi += data.total;
                        this.data[data.date - 1].total_pagi += data.total;
                    }
                    else{
                        this.stats.malam += data.total;
                        this.data[data.date - 1].total_malam += data.total;
                    }   

                    var format = "hh:mm:ss"
                    let timeNow = data.hour + ":" + data.minute + ":00";
                    var time = moment(timeNow , format)

                    let timeStartArray = ["06:30:00" , "15:00:00" , "16:30:00", "20:30:00" , "03:00:00" ,"04:30:00"];
                    let timeEndArray = ["09:00:00" , "16:30:00" , "20:30:00" , "22:00:00" , "04:30:00 ","06:30:00"];
                    let header = ["jam_0630_09" , "jam_15_1630" , "jam_1630_OT" , "jam_2030_22" , "jam_03_0430", "jam_0430_OT"]
                    let done = false;
                    

                    for(var i = 0 ; i < timeStartArray.length ; i++){
                        if(time.isBetween(moment(timeStartArray[i], format) , moment(timeEndArray[i], format))){
                            done = true;
                            this.data[data.date - 1][header[i]] += data.total;
                            break;
                        }
                    }

                    if(!done){
                        let startHourString = data.hour >= 10 ? data.hour.toString() : "0" + data.hour.toString();
                        let endHourString = data.hour + 1 >= 10 ? (data.hour + 1).toString() : "0" + (data.hour + 1).toString();
                        
                        let headerParam =  "jam_" + startHourString + "_" + endHourString;
                        this.data[data.date - 1 ][headerParam] += data.total;
                    }
                   
                    let vehicleTypes = data.data;

                    let monthLength = moment().daysInMonth();
                    for(var i = 0 ; i < vehicleTypes.length ; i++){
                        let found = 0;
                        
                        for(var j = 0 ; j < this.anotherData.vehicleTypeByDay.length ; j++){
                            if(vehicleTypes[i].name == "No Name" && this.anotherData.vehicleTypeByDay[j].name == null){
                                // console.log('a');
                                this.anotherData.vehicleTypeByDay[j].mapped[data.date - 1] += vehicleTypes[i].count;
                                found = 1 ;
                                break;
                            }
                            else if(vehicleTypes[i].name == this.anotherData.vehicleTypeByDay[j].name){
                                this.anotherData.vehicleTypeByDay[j].mapped[data.date - 1] += vehicleTypes[i].count;
                                found = 1;
                                break;
                            }
                                
                        }

                        if(found == 0){
                            
                            let obj = {
                                name : vehicleTypes[i].name,
                                mapped : []
                            }

                            for(var k = 0; k < monthLength ; k ++){
                                if(k == data.date - 1)
                                    obj.mapped.push(vehicleTypes[i].count);
                                else
                                    obj.mapped.push(0)
                            }
                            
                            this.anotherData.vehicleTypeByDay.push(obj);

                        }
                    }
                    
                }
            }
        },
        methods : {
            numberWithCommas(x) {
                return parseInt(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            async getData(flag){
                // Initialise required variables
                if(!this.anotherData) this.anotherData = {vehicleTypeByDay: null} 

                let url = "/api/vehicle/incoming" + this.$store.state.filterUrl;
                this.stats.pagi = 0;
                this.stats.malam = 0;
                this.stats.total = 0;
                
                this.data = [];


                this.$http.get(url)
                .then((resp)=>{
                    this.data = resp.data.data;

                    var tzoffset = (new Date()).getTimezoneOffset() * 60000;

                    for(var i = 0 ; i < this.data.length ; i++){
                        this.stats.pagi += parseInt(this.data[i].total_pagi);
                        this.stats.malam += parseInt(this.data[i].total_malam);
                        this.stats.total += parseInt(this.data[i].total);
                        this.data[i].tgl = new Date(new Date(this.data[i].tgl) - tzoffset).getDate();
                    }
                })
                .catch((err)=>{
                    console.log(err);
                })

                // Due to barbaric data structure, this method is used...........
                let res = await this.$http.get(`api/vehicle/count/map-type-by-day${this.$store.state.filterUrl}`)
                if(res && res.data && res.data.data) {
                    this.anotherData.vehicleTypeByDay = res.data.data
                } else {
                    console.log("An error occured during Daily Vehicle Type by Day data retrieval")
                }
                return 0;
            },
            initialiseFilter() {
                const keys = Object.keys(this.filter)
                let stringUrl = '?'

                for (let i = 0; i < keys.length; i++) {
                    const val = this.filter[keys[i]]
                    if (val !== null && val !== undefined) {
                        stringUrl += `${keys[i]}=${val}&`
                    }
                }

                stringUrl = stringUrl.slice(0, -1)
                this.$store.state.filterUrl = stringUrl
                this.filterReady = true
            },
            search(){
                this.getData()
                this.filterTable = JSON.parse(JSON.stringify(this.filter))
            }
        }
    }
</script>

